import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../services/auth";
import { Link, useNavigate } from "react-router-dom";
import logoNew from "../assets/images/logoNew.png";
import { useDispatch } from "react-redux";
import { loginAction } from "../redux/actions/loginAction";
import { showFormErrors } from "../utils/commonFunctions";
import { allValidations } from "../utils/formValidations";
import { CustomForm, CustomInput, CustomPassword } from "../shared/AllInput";
import PrimaryButton from "../shared/Button/PrimaryButton";
import CustomCard from "../shared/Card/CustomCard";
import Background from "../shared/Background/Background";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        document.documentElement.style.fontSize = 14 + "px";
        if (isAuthenticated()) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        email: "",
        password: "",
    });

    const handleChange = ({ name, value }) => {
        const formErrors = allValidations(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (showFormErrors(data, setData)) {
            dispatch(loginAction(data, setLoading, navigate));
        }
    };

    return (
        <Background>
            <div className="z-1 relative grid mt-5">
                <div className="col-11 md:col-6 mx-auto">
                    <CustomCard className="light" backable={false}>
                        <div className="text-center">
                            <img src={logoNew} alt="logo" style={{ width: "300px" }} />
                        </div>
                        <h2 className="text-4xl mb-3">Login</h2>
                        <CustomForm>
                            <form onSubmit={handleSubmit} className="col-12">
                                <CustomInput col="12" data={data} onChange={handleChange} name="email" label="Email" required />
                                <CustomPassword col="12" data={data} onChange={handleChange} name="password" label="Password" required />
                                <br />
                                <PrimaryButton label="Login" loading={loading} type="submit" />
                            </form>
                        </CustomForm>
                        <div className="text-right mt-4">
                            <Link to="/forgetpassword" className="text-decoration-none">
                                &nbsp;
                                <span className="h6 navyColor font_bolder text-right">Forgot Password?</span>
                            </Link>
                        </div>
                    </CustomCard>
                </div>
            </div>
        </Background>
    );
};
export default Login;
